/**
 * SemLeituraSelo — o carimbo "sem leitura deste recurso" (TASK-10813).
 *
 * 14/09/2026, 20:45: o @Atendente rascunhou um chamado dizendo "com toda a
 * evidência técnica coletada" e nomeando uma causa raiz (o Security Group da
 * `openClaw` bloqueando 100% das portas). 20:46, um minuto depois: "a
 * plataforma ainda não está conseguindo resolver o nome do ambiente para
 * carregar os recursos". Não houve leitura nenhuma — e a causa era falsa.
 *
 * O desenho escolhido pelo proprietário em 16/09 (a saída "(c)" do card) é
 * este: **carimbar, não gatear**. O texto com causa inventada ainda pode sair;
 * o que ele não pode mais é sair parecendo verificado. As outras duas saídas —
 * uma segunda passada do modelo conferindo o texto contra os laudos, e um
 * portão que exige o modelo citar a checagem — impedem o texto, mas custam uma
 * chamada por turno ou reescrevem o contrato de resposta.
 *
 * Quem decide é o SERVIDOR (`chat_bot._proposal_payload`, campo `sem_leitura`):
 * este componente só desenha. Não há regra local sobre quando mostrar — seria o
 * mesmo antipadrão do `ACTION_GATES`, mapa no `.tsx` divergindo da verdade do
 * backend.
 *
 * Laranja e não o teal da marca, de propósito: o teal do cartão significa "ação
 * disponível". Um aviso de ausência de leitura não pode usar a cor que diz que
 * está tudo certo.
 */
import { Badge, Tooltip } from '@mantine/core'
import { IconEyeOff } from '@tabler/icons-react'

export function SemLeituraSelo() {
  return (
    <Tooltip
      label={
        'Nenhum diagnóstico do @DevOps foi executado neste turno — nada aqui ' +
        'foi lido do ambiente. Peça "@DevOps, diagnostique esta máquina" antes ' +
        'de tratar a causa descrita como verificada.'
      }
      multiline
      w={320}
      withArrow
      position="top"
    >
      <Badge
        size="xs"
        color="orange"
        variant="light"
        leftSection={<IconEyeOff size={11} />}
        style={{ textTransform: 'none', cursor: 'help' }}
      >
        sem leitura deste recurso
      </Badge>
    </Tooltip>
  )
}
